import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createStore, StateMachineProvider } from 'little-state-machine';
import LocationPricingCalculator from '../locationCreation/locationPriceCalculator/LocationPricingCalculator';
import { CustomPricingPropType } from '../../hooks/useCustomPricing';
import OrganizationContext from '../../contexts/OrganizationContext';
import { PLAN_TYPES } from '../../common/constants';

/**
 * Small wrapper around the LocationPricingCalculator
 * to show it on the /pricing page.
 */
function PricingPageCalculator({ customPricing }) {
  createStore({
    locationCreateData: {
      plan: PLAN_TYPES.MADE_TO_ORDER,
    },
  });

  return (
    <OrganizationContext.Provider value={{ is_business: true }}>
      <StateMachineProvider>
        <BrowserRouter>
          <LocationPricingCalculator
            hideButtons
            givenPricing={customPricing}
          />
        </BrowserRouter>
      </StateMachineProvider>
    </OrganizationContext.Provider>
  );
}

PricingPageCalculator.propTypes = {
  customPricing: CustomPricingPropType.isRequired,
};

export default PricingPageCalculator;
